<template>
  <div :class="[$options.name]" class="tw:flex-1 tw:overflow-y-scroll tw:p-4 tw:sm:p-6">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneDrawerContent",
  setup() {
    return {};
  },
});
</script>
